/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_NInputs */

const en_mk_tut_tim_n = /** @type {(inputs: Mk_Tut_Tim_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A member only sees public channels and the channels of their division. Private channels and direct messages stay closed until they are invited in.`)
};

const id_mk_tut_tim_n = /** @type {(inputs: Mk_Tut_Tim_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota hanya melihat channel publik dan channel divisinya. Channel privat dan pesan langsung tetap tertutup sampai mereka diajak masuk.`)
};

/**
* | output |
* | --- |
* | "A member only sees public channels and the channels of their division. Private channels and direct messages stay closed until they are invited in." |
*
* @param {Mk_Tut_Tim_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_n = /** @type {((inputs?: Mk_Tut_Tim_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_n(inputs)
	return en_mk_tut_tim_n(inputs)
});